import ScopeEmissionForm from "./ScopeEmissionForm";

const Scope3Form = () => (
  <ScopeEmissionForm scopeKey="scope3" label="Scope 3 Emissions" />
);

export default Scope3Form;
